import * as THREE from "three";




export function initLights(faceTrackerGroup: any, scene: THREE.Scene) {
  scene.add(new THREE.AmbientLight(0xffffff, 2.5));

  let directionalLight = new THREE.DirectionalLight(0xffffff, 5);
  const targetObject = new THREE.Object3D();
  faceTrackerGroup.add(targetObject);
  faceTrackerGroup.add(directionalLight);
  directionalLight.target = faceTrackerGroup;
  //directionalLight.position.set(-10, 3, 0);
  directionalLight.position.set(-2, 1, 0.2);
  directionalLight.castShadow = true;

}
